import { Link } from '../../components/Toolkit/Button/Link';

import type {
  Section,
  SitemapPageProps,
  Subsection,
} from '../../components/Sitemap/SitemapPage.typed';

import * as Styled from '../../components/Sitemap/SitemapPage.styled';

const SitemapPage = (props: SitemapPageProps) => {
  const { sections } = props;

  const TITLE_COPY = 'DoneDeal Sitemap';

  return (
    <div className="row set-width-100">
      <div className="columns small-12">
        <Styled.Container>
          <Styled.Title>{TITLE_COPY}</Styled.Title>
          <Styled.Sections>{MapSections(sections)}</Styled.Sections>
        </Styled.Container>
      </div>
    </div>
  );
};

const MapSections = (sections: Section[]) => {
  return sections.map((section: Section) => {
    const { name, displayName, subsections } = section;

    const displaySubsections = Boolean(subsections.length > 0);

    const HREF = `/${name}`;
    const LINK_TYPE = 'SECONDARY';
    const LINK_COLOR_VARIANT = 'GREY_DARKER';

    return (
      <li key={name}>
        <Styled.SectionTitle>
          <Link
            href={HREF}
            ofType={LINK_TYPE}
            colorVariant={LINK_COLOR_VARIANT}
            fontSize="B18"
          >
            <b>{displayName}</b>
          </Link>
        </Styled.SectionTitle>
        {displaySubsections && (
          <Styled.Subsections>{MapSubsections(subsections)}</Styled.Subsections>
        )}
      </li>
    );
  });
};

const MapSubsections = (subsections: Subsection[]) => {
  return subsections.map((subsection: Subsection) => {
    const { name, displayName } = subsection;

    const HREF = `/${name}`;
    const LINK_TYPE = 'SECONDARY';
    const LINK_COLOR_VARIANT = 'GREY_DARK';

    return (
      <Styled.ListItem key={name}>
        <Link
          href={HREF}
          ofType={LINK_TYPE}
          fontSize="M14"
          colorVariant={LINK_COLOR_VARIANT}
        >
          {displayName}
        </Link>
      </Styled.ListItem>
    );
  });
};

export { SitemapPage };
